import api, { request } from '../../../api';
import { IActionGroup, IStore } from '../../index';
import { IAddon, IAdminEventsStore, ICoupon, IPrice } from '../events/store';

import { IErrorsStore } from '../../errors/store';

export enum FeeType {
  'PRICE' = 'prices',
  'COUPON' = 'coupons',
  'ADDON' = 'addons'
}

export interface IAdminFeesActions extends IActionGroup {
  create: (
    clubId: number,
    feeType: FeeType,
    item: IAddon | ICoupon | IPrice
  ) => { event?: IAdminEventsStore; errors?: IErrorsStore };
  edit: (
    clubId: number,
    feeType: FeeType,
    item: IAddon | ICoupon | IPrice
  ) => { event?: IAdminEventsStore; errors?: IErrorsStore };
  remove: (
    clubId: number,
    feeType: FeeType,
    item: IAddon | ICoupon | IPrice
  ) => { event?: IAdminEventsStore; errors?: IErrorsStore };
}

const actions: IActionGroup = {
  create: async (
    state: IStore,
    clubId: number,
    feeType: FeeType,
    item: IAddon | ICoupon | IPrice
  ) => {
    const response = await request.post(api.admin[feeType](clubId, item.event), item);
    if (response.error) {
      return {
        errors: { fees: { msg: `Error creating: ${response.error.statusText}` } }
      };
    }

    const event = state.adminEvents[item.event];

    const storeValue: any[] = event[feeType] || [];
    const newValues = storeValue.concat(response);

    const newEvent = {
      ...event,
      [feeType]: newValues
    };

    return {
      adminEvents: {
        all: {
          ...state.adminEvents.all,
          [newEvent.id]: newEvent
        },
        current: newEvent,
        [newEvent.id]: newEvent
      }
    };
  },

  edit: async (
    state: IStore,
    clubId: number,
    feeType: FeeType,
    item: IAddon | ICoupon | IPrice
  ) => {
    const response = await request.patch(
      `${api.admin[feeType](clubId, item.event)}${item.id}/`,
      item
    );

    if (response.error) {
      return {
        errors: { fees: { msg: `Error editing: ${response.error.statusText}` } }
      };
    }

    const event = state.adminEvents[item.event];
    const newValues = (event[feeType] as any[]).map((feeItem: any) =>
      feeItem.id === response.id ? response : feeItem
    );

    const newEvent = {
      ...event,
      [feeType]: newValues
    };

    return {
      adminEvents: {
        all: {
          ...state.adminEvents.all,
          [newEvent.id]: newEvent
        },
        current: newEvent,
        [newEvent.id]: newEvent
      }
    };
  },

  remove: async (
    state: IStore,
    clubId: number,
    feeType: FeeType,
    item: IAddon | ICoupon | IPrice
  ) => {
    const response = await request.delete(`${api.admin[feeType](clubId, item.event)}${item.id}/`);

    if (response.error) {
      const errorMessages = {
        addons: 'Error Deleting the event addon.',
        coupons: 'Error Deleting the event coupon.',
        prices: 'Error Deleting the event price.'
      };
      return { errors: { fees: { msg: errorMessages[feeType] } } };
    }

    const event = state.adminEvents[item.event];
    const newValues = (event[feeType] as any).filter((i: any) => i.id !== item.id);
    const newEvent = {
      ...event,
      [feeType]: newValues
    };

    return {
      adminEvents: {
        all: {
          ...state.adminEvents.all,
          [newEvent.id]: newEvent
        },
        current: newEvent,
        [newEvent.id]: newEvent
      }
    };
  }
};

export default actions;
